module.exports = __webpack_public_path__ + "static/media/1.eb8d13ec.png";